import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { FileText, Video, BarChart3, BookOpen } from 'lucide-react';

const PublicationsSection = () => {
  const publicationTypes = [
    {
      id: 1,
      title: 'Process Documents',
      icon: FileText,
      description: 'Detailed documentation of our working processes and methodologies'
    },
    {
      id: 2,
      title: 'Audio Visual Documents',
      icon: Video,
      description: 'Video documentation and multimedia content of our work'
    },
    {
      id: 3,
      title: 'Impact Documents',
      icon: BarChart3,
      description: 'Comprehensive reports on the impact of our interventions'
    },
    {
      id: 4,
      title: 'IEC Material',
      icon: BookOpen,
      description: 'Information, Education, and Communication materials'
    }
  ];

  return (
    <section id="publications" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Our Publications
          </h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto mb-8"></div>
          <p className="text-gray-600 max-w-4xl mx-auto text-lg leading-relaxed">
            A lot of organizations work well at grassroots level but very few of them have indigenous 
            capacity to document the same and come out with qualitative publications. At Prayatne, we 
            understand the importance of qualitative documentation and publication and, therefore, make 
            intensive efforts in this regard.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {publicationTypes.map((type) => {
            const Icon = type.icon;
            return (
              <Card
                key={type.id}
                className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group cursor-pointer"
              >
                <CardContent className="p-8 text-center">
                  <div className="mb-6 flex justify-center">
                    <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center group-hover:bg-orange-600 transition-colors duration-300">
                      <Icon className="text-orange-600 group-hover:text-white transition-colors duration-300" size={36} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">
                    {type.title}
                  </h3>
                  <p className="text-gray-600">{type.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="bg-gray-50 rounded-lg p-8 md:p-12">
          <p className="text-gray-600 leading-relaxed mb-6">
            We build capacity of our grassroots level team and encourage them to document their work as 
            an ongoing process. At the same time, we have developed a cell to conceptualize the documents, 
            guide the grassroots level team for their preparation, translate these documents if required, 
            edit them and design them so that they take a shape that is felt interesting by the readers 
            and are able to communicate the desired message to them in an effective manner.
          </p>
          <p className="text-gray-600 leading-relaxed mb-8">
            Through this process, we have developed several process as well as impact documents. Of late, 
            we have ventured into video documentation as well.
          </p>
          <div className="text-center">
            <Button className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg">
              Explore All Publications
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PublicationsSection;